import React from 'react'

export const COLUMNS_DISTRIBUCION_POR_ESPACIO = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'espacioEnCamionesSector12',
    label: 'Sector 1-2 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesSector3',
    label: 'Sector 3 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesSector4',
    label: 'Sector 4 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnCamionesSector5',
    label: 'Sector 5 [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsSector12',
    label: 'Sector 1-2 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsSector3',
    label: 'Sector 3 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsSector4',
    label: 'Sector 4 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioEnTnsSector5',
    label: 'Sector 5 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Total [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_DISTRIBUCION_POR_ESPACIO_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesSector12',
    label: 'Espacio S 1-2 [Camiones]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesSector3',
    label: 'Espacio S 3 [Camiones]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesSector4',
    label: 'Espacio S 4 [Camiones]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnCamionesSector5',
    label: 'Espacio S 5 [Camiones]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsSector12',
    label: 'Espacio S 1-2 [Tn]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsSector3',
    label: 'Espacio S 3 [Tns]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsSector4',
    label: 'Espacio S 4 [Tns]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioEnTnsSector5',
    label: 'Espacio S 5 [Tns]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Espacio Total [Camiones]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Espacio Total [Tn]',
    width: 70,
    mantenerCase: true
  }
]
